import { NBSP_JS } from 'constants/unicode/nbsp-js';

export const SECTION_TITLE = `${NBSP_JS}`;
